module.exports = __webpack_public_path__ + "img/thumbnail_AmericanFlamingo_f_normal.2ca4b1f3.png";